import React, { memo } from 'react';
import { Dashboard } from '../../../../../types/files';
import DashboardStatusMenu from '../../../../molecules/dashboard-menus/DashboardStatusMenu';

const StatusCell: React.FC<{ dashboard: Dashboard; readOnly?: boolean }> = ({ dashboard, readOnly }) => {
    return (<>
        <DashboardStatusMenu dashboard={dashboard} readOnly={readOnly} statusHistory={!!dashboard.status ? [
            { status: dashboard.status, timestamp: dashboard.createdAt },
        ] : []}
/>
    </>);
}

export default memo(StatusCell);
